// -- FOLDER COLORS --

// ICON
export const FOLDER_FILL_COLOR = 'fill-blue-200';
export const FOLDER_STROKE_COLOR = 'stroke-blue-300';
